import { Fragment } from 'react'
import { observer } from 'mobx-react-lite'
import { entries } from 'remeda'
import { Box } from '../Box/Box'

export const DebugInfo = observer(function DebugInfo<
  T extends Record<string, unknown>,
>({ info, ...props }: { info: T; className?: string }) {
  return (
    <Box as="dl" variant="styles.debugDefinitionList" {...props}>
      {entries(info).map(([k, v]) => (
        <Fragment key={k}>
          <dt>{k}</dt>
          <dd>{String(v)}</dd>
        </Fragment>
      ))}
    </Box>
  )
})
